export default {
  namespaced: true,
  state: {
    isPlaying: false,
    currentBgm: null,
  },
  getters: {
    isPlaying(state) {
      return state.isPlaying
    },
    currentBgm(state) {
      return state.currentBgm
    },
  },
  mutations: {
    setIsPlaying(state, bool){
      state.isPlaying = bool
    },
    setCurrentBgm(state, bgm){
      state.currentBgm = bgm
    },
  }
}